/** Where the active tenant choice is remembered between reloads (tenant id only, per tab). */
export const ACTIVE_TENANT_KEY = 'sprocket.activeTenant';
export function readActiveTenant() {
    try {
        return sessionStorage.getItem(ACTIVE_TENANT_KEY);
    }
    catch {
        return null;
    }
}
export function writeActiveTenant(tenantId) {
    try {
        if (tenantId)
            sessionStorage.setItem(ACTIVE_TENANT_KEY, tenantId);
        else
            sessionStorage.removeItem(ACTIVE_TENANT_KEY);
    }
    catch {
        // Storage blocked: the choice simply does not survive a reload.
    }
}
/**
 * The initial active tenant (identity lane rule): the hint the person arrived with when it is
 * a membership, else the one remembered in this tab, else the only membership, else the home
 * tenant from the token, else none (the picker decides).
 */
export function chooseInitialTenant(workspaceIds, hints) {
    const has = (id) => typeof id === 'string' && workspaceIds.includes(id);
    if (has(hints.tenantHint))
        return hints.tenantHint;
    if (has(hints.remembered))
        return hints.remembered;
    if (workspaceIds.length === 1)
        return workspaceIds[0] ?? null;
    if (has(hints.home))
        return hints.home;
    return null;
}
//# sourceMappingURL=active-tenant.js.map